import { render } from "./FooterComponent.vue?vue&type=template&id=7b5008eb&scoped=true&ts=true"
import script from "./FooterComponent.ts?vue&type=script&lang=ts"
export * from "./FooterComponent.ts?vue&type=script&lang=ts"

import "./FooterComponent.scss?vue&type=style&index=0&id=7b5008eb&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b5008eb"]])

export default __exports__